<div class="" *ngIf="!disabled">
  <label *ngIf="label">{{ label }} <span *ngIf="required" class="text-danger">*</span></label>
  <div class="form-control-custom">
    <input type="file" (change)="fileChange($event);" [accept]="accept || '.xls, .xlsx'" />
    <p class="small-custom">{{fn}}</p>
  </div>
</div>
